module.exports = __webpack_public_path__ + "static/media/power-off.81acf50a.svg";